<template>
	<div>
		<Top></Top>
		<div class="wd-container wd-h-40 wd-lh-40 wd-m-t-20">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>帮助中心</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="wd-flex wd-row-between wd-container list wd-col-top">
			<div class="left wd-row-noshrink ">
				<template  v-for="(item,index) in classlist">
					<div class="title" :key="index">
						{{item.name}}
					</div>
					<div v-for="(ditem,dindex) in item.detail" :key="dindex+'-'+index">
						<div class="subtitle" @click="loadinfo(ditem.id)">{{ditem.title}}</div>		
					</div>
				</template>
			</div>
			<div class="right wd-row-grow">
				<div class="title">
					<span class="sx"></span>
					<span>{{wdinfo.title}}</span>
				</div>
				<div class="detail" v-html="wdinfo.detailmsg">
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Top from '@/components/layout/Top.vue';
import Footer from '@/components/layout/Footer.vue';
export default {
	name: 'Help',
	components: {
		Top,
		Footer
	},
	data() {
		return {
			hotlist: [],
			goodsinfo: {},
			goodsid: '',
			goodspiclist: [],
			classlist:[],
			wdinfo:{
				title:"",
				
			},
			studyid:''
		};
	},
	watch: {
		$route() {
			var studyid=this.$route.query.studyid||""
			if (studyid!=='' && studyid!=this.studyid){
				this.studyid=studyid;
				this.loadinfo(studyid);
			}
		}
	},
	methods: {
		loadclass(){
			this.$wd_request("studyclass",{classname:"商城帮助",help:1})
			.then(data=>{
				this.classlist=data.value;
				if (this.studyid===""){
					for (var i = 0; i < data.value.length; i++) {
						var item=data.value[i].detail
						for(let j in item){
							this.loadinfo(item[j].id);
							return;
						}
					}
				}
			})
			.catch(()=>{})
		},
		loadinfo(studyid){
			this.wdinfo={};
			this.stuyid=studyid;
			this.$wd_request("studylist",{studyid:studyid,cnt:1},true,".right")
			.then(data=>{
				this.wdinfo=data.value[0];
			})
			.catch(()=>{})
		}
	},
	created() {
		this.loadclass();
		var studyid=this.$route.query.studyid||""
		if (studyid!=='' && studyid!=this.studyid){
			this.studyid=studyid;
			this.loadinfo(studyid);
		}
	}
};
</script>

<style lang="scss" scoped>
.list {
	.left {
		width: 148px;
		overflow: hidden;
		border: 1px $wd-border solid;
		.title {
			height: 34px;
			padding-left: 10px;
			line-height: 34px;
			font-weight: bold;
			font-size: 14px;
			background: #f4f4f4;
			color: #3c3c3c;
		}
		.subtitle {
			display: block;
			font-size: 12px;
			color: #3c3c3c;
			cursor: pointer;
			text-align: center;
			height: 34px;
			line-height: 34px;
			&:hover {
				color: $wd-blue;
				text-decoration: underline !important;
			}
		}
	}
	.right {
		margin-left: 20px;
		border: 1px solid $wd-border;
		.title {
			color: rgb(60, 60, 60);
			padding-top: 4px;
			padding-bottom: 4px;
			padding-left: 20px;
			font-size: 14px;
			font-weight: bold;
			height: 30px;
			line-height: 30px;
			border-bottom: 1px solid $wd-border;
			.sx {
				border-left-color: rgb(242, 46, 0);
				border-left-width: 3px;
				border-left-style: solid;
				margin-right: 10px;
			}
		}
		.detail {
			padding: 20px;
		}
	}
}
</style>
